import React from 'react';
import { AutoSizer, List } from 'react-virtualized';
export function AutoSizedList(_ref) {
  var autoSizerClsName = _ref.autoSizerClsName,
      listClsName = _ref.listClsName,
      rowCount = _ref.rowCount,
      _ref$rowHeight = _ref.rowHeight,
      rowHeight = _ref$rowHeight === void 0 ? 34 : _ref$rowHeight,
      rowRenderer = _ref.rowRenderer,
      _ref$onScroll = _ref.onScroll,
      onScroll = _ref$onScroll === void 0 ? function () {} : _ref$onScroll;
  return React.createElement(AutoSizer, {
    className: autoSizerClsName
  }, function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return React.createElement(List, {
      onScroll: onScroll,
      width: width,
      height: height,
      className: listClsName,
      rowHeight: rowHeight,
      rowCount: rowCount,
      rowRenderer: rowRenderer
    });
  });
}